import { render, staticRenderFns } from "./BatteryEdit.vue?vue&type=template&id=6f1225ec"
import script from "./BatteryEdit.vue?vue&type=script&lang=js"
export * from "./BatteryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports